module.exports = __webpack_public_path__ + "media/images/dashboards/controlled-2b1cc7e9b44d5e3b7d4a57f8474d5b82.png";